<template>
  <div>
    <el-table height="calc(100vh - 360px)" :data="displayList">
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="email" label="邮箱"></el-table-column>
      <el-table-column prop="tel" label="手机号"></el-table-column>
      <el-table-column prop="expireTime" label="到期时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.expireTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="剩余时间" width="140">
        <template slot-scope="scope">
          {{ formatRemaining(scope.row.remainingSeconds) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="cancelBlack(scope.row)">
            解除限制
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'AuthLimitList',
  data() {
    return {
      now: Date.now(),
      timer: null
    };
  },
  computed: {
    ...mapState('authLimit', ['auditList']),
    displayList() {
      const current = this.now;
      return this.auditList.map((item) => {
        const expireSeconds = Number(item.expireSeconds);
        const loadedAt = item._loadedAt || current;
        const elapsedSeconds = Math.floor((current - loadedAt) / 1000);
        const remainingSeconds = isFinite(expireSeconds)
          ? Math.max(expireSeconds - elapsedSeconds, 0)
          : null;
        return {
          ...item,
          remainingSeconds
        };
      });
    }
  },
  methods: {
    ...mapActions('authLimit', ['deleteLimit']),
    formatRemaining(seconds) {
      if (seconds === null || seconds === undefined || seconds < 0) {
        return '-';
      }
      const hour = Math.floor(seconds / 3600);
      const minute = Math.floor((seconds % 3600) / 60);
      const second = seconds % 60;
      return [hour, minute, second].map((item) => {
        const text = String(item);
        return text.length < 2 ? `0${text}` : text;
      }).join(':');
    },
    cancelBlack({ userId }) {
      this.$confirm('确认将此用户解除限制吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.deleteLimit({ userId }).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功！'
            });
            this.$emit('refresh');
          }
        });
      });
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="less" scoped></style>
